(function () {
  // Skip in Shopify theme editor
  if (window.Shopify && window.Shopify.designMode) return;

  // Only auto-detect once per browser session to avoid redirect loops
  // and to respect any manual country selection the user makes
  if (sessionStorage.getItem('geo_currency_checked')) return;
  sessionStorage.setItem('geo_currency_checked', 'true');

  // Find the hidden country_code input rendered by the localization form
  var countryInput = document.querySelector('input[name="country_code"]');
  if (!countryInput) return;

  var currentCountry = countryInput.value;

  // Shopify's geolocation endpoint returns the visitor's detected country
  fetch('/browsing_context_suggestions.json')
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      var detected =
        data &&
        data.detected_values &&
        data.detected_values.country &&
        data.detected_values.country.handle;

      // Nothing to do if already on the right country or detection failed
      if (!detected || detected === currentCountry) return;

      // Submit the first available localization form with the detected country
      var form = document.querySelector('form.localization-form');
      if (!form) return;

      var input = form.querySelector('input[name="country_code"]');
      if (!input) return;

      input.value = detected;
      form.submit();
    })
    .catch(function () {
      // Silently ignore network or parse errors
    });
})();
